import { randomUuid } from "../../shared/utils/randomUuid";

type ExcelTask =
  | { type: "export"; sheetName: string; rows: Record<string, unknown>[] }
  | { type: "template" }
  | { type: "parse"; buffer: ArrayBuffer };

type ExcelWorkerResponse<T> = { id: string; ok: true; result: T } | { id: string; ok: false; error: string };

export async function buildExcelInBackground(sheetName: string, rows: Record<string, unknown>[]) {
  return runExcelWorker<ArrayBuffer>({ type: "export", sheetName, rows });
}

export async function buildMemberTemplateInBackground() {
  return runExcelWorker<ArrayBuffer>({ type: "template" });
}

export async function parseMemberWorkbookInBackground(buffer: ArrayBuffer) {
  return runExcelWorker<Record<string, string>[]>({ type: "parse", buffer }, [buffer]);
}

function runExcelWorker<T>(task: ExcelTask, transfer: Transferable[] = []) {
  return new Promise<T>((resolve, reject) => {
    const worker = new Worker(new URL("./excelWorker.ts", import.meta.url), { type: "module", name: "boom-tennis-excel" });
    const id = randomUuid();
    worker.onmessage = (event: MessageEvent<ExcelWorkerResponse<T>>) => {
      if (event.data.id !== id) return;
      worker.terminate();
      if (event.data.ok) resolve(event.data.result);
      else reject(new Error(event.data.error));
    };
    worker.onerror = () => {
      worker.terminate();
      reject(new Error("Excel后台处理线程启动失败，请刷新后重试。"));
    };
    worker.postMessage({ id, ...task }, { transfer });
  });
}
